import { render, staticRenderFns } from "./cancelReqEnrollment.vue?vue&type=template&id=4ec0cff2&"
import script from "./cancelReqEnrollment.vue?vue&type=script&lang=js&"
export * from "./cancelReqEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports